<!-- <nav *ngIf="type !='logged'" class="navbar navbar-expand-lg navbar-light bg-light header">
    <div class="logo"><a routerlink="/login"><img src="assets/logo-4.png"></a></div>
</nav>
 -->

 <nav  class="navbar navbar-expand-lg navbar-light bg-light header">
    <div class="container-fluid dashboard-container">
      <div class="row">
        <div class="col">
          <div class="row d-flex justify-content-center">
            <div class="col-md-2">
              <div class="logo">
                <a><img src="assets/logo-4.png" /></a>
                <div class="logo-light"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  
  
  <ng-template #content let-modal>
  
    <button type="button" class="btnn btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">X</button>
  
    <div class="modal-body modal-body1">
      <form>
        <div class="mb-3 d-flex flex-wrap text-center justify-content-center">
          <!-- <img class="logoo" src="../../assets/logo-5.png" /> -->
          <h3 class="w-100 ">Subscription Required</h3>
          <h6 class="w-100 my-3">Would you like to upgrade your business?</h6>
          <p class="w-100 mt-2">
            <button (click)="goToSubscribe()" class="btn btn-primary">Review Plans</button>
            <button (click)="goToDashboard()"  class="btn btn-danger ml-2">Cancel</button>
          </p>
        </div>
      </form>
    </div>
  </ng-template>